<template>
  <div class="scrollable-element" ref="scrollable" style="padding-top: 56px">
    <div class="button_box fixed-element">
      <el-button type="primary" size="medium" v-for="(item, i) in checkupSortButtons" @click="filterCheckup(i)"
                 :key="i" :class="buttonIndex === i ? 'button_color1' : 'button_color0'">{{ item.type }}{{ item.num }}
      </el-button>
    </div>
    <div v-for="(checkup,i) in assignViewCheckups" :key='i + "" + checkup.questCode + checkup.id'>
      <div v-if="checkup.status === 10" @click="start(checkup)">
        <el-card class="box-card">
          <el-row class="parent_box">
            <el-col :span="22">
              <el-col :span="7">
                <div class="quest_finish_left">
                  <div>指派时间</div>
                  <div>测评名称</div>
                  <div>咨询师</div>
                  <div>题量</div>
                  <div style="margin-bottom: 0">测评介绍</div>
                </div>
              </el-col>
              <el-col :span="17">
                <div class="quest_finish_right">
                  <div>{{ checkup.createTime }}</div>
                  <div>{{ parseQuestNameByCode(checkup.questCode) }}</div>
                  <div>{{ checkup.teacher.teacherName }}</div>
                  <div>{{ getQuestByCode(checkup.questCode).arrQuestion.length }}</div>
                </div>
              </el-col>
              <div style="font-weight: normal;font-size: 13px;margin: 10px">
                {{ getQuestIntroByCode(checkup.questCode) }}
              </div>
              <el-button class="quest_button large-btn quest_button_assess" type="text"
                         size="medium" @click="start(checkup)">
                待测评
              </el-button>
            </el-col>
            <el-col :span="2" class="child_box">
              <div class="quest_arrow child_box">
                <i class="el-icon-arrow-right"/>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>


      <div v-if="checkup.status === 20">
        <el-card class="box-card">
          <el-row class="parent_box">
            <el-col :span="22">
              <el-col :span="7">
                <div class="quest_finish_left">
                  <div>指派时间</div>
                  <div>测评名称</div>
                  <div>咨询师</div>
                  <div>完成时间</div>
                  <div style="margin-bottom: 0">测评介绍</div>
                </div>
              </el-col>
              <el-col :span="17">
                <div class="quest_finish_right">
                  <div>{{ checkup.createTime }}</div>
                  <div>{{ parseQuestNameByCode(checkup.questCode) }}</div>
                  <div>{{ checkup.teacher.teacherName }}</div>
                  <div>{{ checkup.updateTime }}</div>
                </div>
              </el-col>
              <div style="font-weight: normal;font-size: 13px;margin: 10px">
                {{ getQuestIntroByCode(checkup.questCode) }}
              </div>
              <el-button class="quest_button large-btn quest_button_assess" type="success"
                         size="medium" @click="buildReport(checkup.questId)"
                         v-loading.fullscreen.lock="fullscreenLoading">
                查看报告
              </el-button>
            </el-col>
            <el-col :span="2" class="child_box">
              <div class="quest_arrow child_box">
                <!--              <i class="el-icon-arrow-right"/>-->
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>

    </div>


  </div>
</template>

<script>

import HttpRequest from "../utils/request";
import {mapState} from "vuex";
import {getQuestByCode} from "../assets/js/quest";
import {getQuestIntroByCode, parseQuestNameByCode} from "../assets/js/questIntro";

export default {
  data() {
    return {
      fullscreenLoading: false,
      buttonIndex: 0,
      checkupSortButtons: [
        {type: '全部', num: 0},
        {type: '待测评', num: 0},
        {type: '已完成', num: 0}
      ],
      assignCheckups: [],
      assignViewCheckups: [],
    }
  },
  computed: {
    ...mapState({
      student: (state) => state.user.student,
    }),
  },
  created() {
    this.buttonIndex = parseInt(this.$route.query.code)
    this.getAssignQuests()
  },
  mounted() {
    document.title = '指派测评';
  },
  methods: {
    getQuestByCode,
    parseQuestNameByCode,
    getQuestIntroByCode,
    //获取获取指派测评
    getAssignQuests() {
      let url = "/constub/getFreeOrAssignQuests";
      let data = {token: this.student.token, type: 'assign'};
      HttpRequest.requestFormPost(url, data).then(res => {
        if (res && res.result.success) {
          let assignCheckups = res.data
          this.assignCheckups = assignCheckups
          this.filterCheckup(this.buttonIndex)
          assignCheckups.forEach(q =>{
            if (q.status === 10){
              this.checkupSortButtons[0].num += 1
              this.checkupSortButtons[1].num += 1
            }else if (q.status === 20){
              this.checkupSortButtons[0].num += 1
              this.checkupSortButtons[2].num += 1
            }
          })
        } else {
          this.$alert(res.result.message, {confirmButtonText: '确定', showClose: false,});
        }
      });
    },
    start(checkup) {
      let data = {
        questCode: checkup.questCode,
        checkupId: checkup.id,
        type: checkup.type,
        questId: checkup.questId
      }
      this.$router.push({
        name:'questIntro',
        params:{
          'questId':checkup.questId,
          'checkupId':checkup.id,
          'questCode':checkup.questCode,
          'type':checkup.type
        }
      })
    },
    filterCheckup(status) {
      this.buttonIndex = status;
      if (status === 0) {
        this.assignViewCheckups = this.assignCheckups
      }else {
        let s = status === 1 ? 10 : 20
        this.assignViewCheckups = this.assignCheckups.filter(q => q.status === s);
      }
    },
    buildReport(questId) {
      this.fullscreenLoading = true;
      //
      let url = "/constub/buildReport";
      let data = {token: this.student.token, questId: questId};
      HttpRequest.requestFormPost(url, data).then(res => {
        this.fullscreenLoading = false;
        if (res && res.result.success) {
          let pdfUrl = res.data;
          // window.open(pdfUrl,'_blank');
          // 在延迟后打开新标签页 解决Safari浏览器不支持的问题
          setTimeout(function() {
            window.open(pdfUrl, '_blank');
          }, 1); // 设置延迟时间为1毫秒
        } else {
          this.$alert(res.result.message, {confirmButtonText: '确定', showClose: false,});
        }
      });
    }
  }

}
</script>

<style scoped>
.button_box {
  background-color: #cfd6ed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  font-size: 30px;
}

.box-card {
  padding: 10px 15px;
}

.quest_button {
  width: 100%;
  margin-top: 10px;
  text-align: center;
}

.button_box button {
  width: 30%;
}

.button_color0 {
  background-color: #FDFDFD;
  border-color: snow;
  color: #000;
}

.button_color1 {
  background-color: #409DFD;
  /*border-color: snow;*/
  color: #FFF;
}

.quest_arrow, i {
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 25px;
}

.quest_finish_left > div {
  text-align: justify;
  text-align-last: justify;
  margin: 5px;
  color: #404c9a;
}

.quest_finish_right div {
  margin: 5px 0 5px 0;
  font-weight: bold;
}

.parent_box {
  position: relative;
}

.child_box {
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
}

.quest_button_assess {
  width: 110%;
}

.fixed-element {
  background: #d0d7ee;
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 20px 10px;
}
</style>
